import { render, staticRenderFns } from "./Pizza.vue?vue&type=template&id=734d243b&scoped=true&"
import script from "./Pizza.vue?vue&type=script&lang=js&"
export * from "./Pizza.vue?vue&type=script&lang=js&"
import style0 from "./Pizza.vue?vue&type=style&index=0&id=734d243b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734d243b",
  null
  
)

export default component.exports